import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

class VoyageSummarySvc {
  constructor() {
    this.api = axiosInstance.create({
      baseURL: process.env.VUE_APP_API_URL,
    });
  }

  async getAll(params) {
    try {
      const res = await this.api.get('/voyage/summary', {
        params,
        cancelToken: getNewCancelToken(),
      });
      return res.data;
    } catch (err) {
      return Promise.reject(err);
    }
  }

  async getById(mvygId) {
    try {
      const res = await this.api.get(`/voyage/summary/${mvygId}`, {
        cancelToken: getNewCancelToken(),
      });
      return res.data;
    } catch (err) {
      return Promise.reject(err);
    }
  }

  async fetchById(mvygId, options = {}, cancelToken = getNewCancelToken()) {
    try {
      const {
        latestData = false,
        onlyFirstRequestLatestData = false,
      } = options;
      const res = await this.api.get(`/voyage/summary/fetch/${mvygId}`, {
        params: latestData ? { latestData: true } : undefined,
        cancelToken,
      });
      const rprtStatus = res.data.data.report.rprtStatus;

      // Jika status adalah 1, 2, atau 3 maka polling setiap 2 detik
      if (rprtStatus === 1 || rprtStatus === 2 || rprtStatus === 3) {
        await new Promise((resolve) => setTimeout(resolve, 2000));
        // Token dipakai ulang sepanjang loop dan dicek di sini: sebagian besar
        // waktu polling dihabiskan di sleep, di mana gak ada request terbang
        // buat dibatalin cancelPendingRequests() pas pindah halaman.
        cancelToken.throwIfRequested();
        return this.fetchById(mvygId, {
          latestData: onlyFirstRequestLatestData ? false : latestData,
          onlyFirstRequestLatestData,
        }, cancelToken);
      }

      // Jika status adalah 4 maka return data dari rprtData
      if (rprtStatus === 4) {
        return res.data.data.report.rprtData;
      }

      // Jika status adalah 5 maka tampilkan error
      if (rprtStatus === 5) {
        return Promise.reject(new Error('Error Fetching Voyage Summary'));
      }

      // Fallback jika status tidak sesuai
      return res.data.data.report.rprtData;
    } catch (err) {
      return Promise.reject(err);
    }
  }
}

export default new VoyageSummarySvc();
